import React from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { ArrowLeft, CreditCard, RefreshCw, AlertTriangle, CheckCircle } from 'lucide-react';
import { BrandLockup } from './BrandLogo';

const RefundPolicy = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-orange-50">
      <div className="bg-white/80 backdrop-blur-sm border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4 flex items-center space-x-4">
          <Button variant="ghost" onClick={onBack} className="text-gray-600 hover:text-gray-900" data-testid="refund-back-btn">
            <ArrowLeft className="w-5 h-5 mr-2" />Back
          </Button>
          <BrandLockup size="sm" testId="public-brand-lockup" />
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-3xl space-y-8" data-testid="refund-policy-page">
        <div className="text-center">
          <CreditCard className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-3">Payments & Refunds</h1>
          <p className="text-gray-600">Last updated: June 2026</p>
        </div>

        <Card className="p-8 space-y-4 text-gray-700">
          <div className="flex items-start space-x-3">
            <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Free to join</h2>
              <p>Creating a profile, discovering people, matching and messaging are free. FlameLink Premium, an optional paid subscription, is being prepared and is <strong>not yet available for purchase</strong>. Nothing is charged until you explicitly start a subscription at checkout.</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <CreditCard className="w-6 h-6 text-rose-500 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900">FlameLink Premium subscriptions</h2>
              <p>Premium will be offered as a recurring subscription (monthly, every 3 months, or yearly). The price, billing period and renewal date are shown before you confirm. Subscriptions <strong>renew automatically</strong> at the end of each billing period and are charged to your payment method by our payment processor, Stripe, until you cancel. FlameLink never stores your full card number.</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <RefreshCw className="w-6 h-6 text-blue-500 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Cancellation and expiration</h2>
              <p>You can cancel at any time from Settings → FlameLink Premium. Cancelling stops future renewals; your Premium features stay active until the end of the period you have already paid for, then your account returns to Free. If a renewal payment fails, Stripe will retry it; if it cannot be collected, the subscription ends and Premium features are removed. Deleting your account also ends any active subscription.</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <AlertTriangle className="w-6 h-6 text-orange-500 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Refunds</h2>
              <p>Subscription payments are generally <strong>non-refundable</strong>, including for partially used billing periods, except where a refund is required by applicable law or where we decide, at our discretion, to grant one. To request a refund, contact us through the Contact page within 14 days of the charge. If a payment is refunded in full, the related subscription is ended and Premium access is removed immediately.</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <AlertTriangle className="w-6 h-6 text-orange-500 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900">About "tip offers"</h2>
              <p>A tip offer is a symbolic amount attached to a like to signal interest. <strong>No money is collected, held, transferred or paid out.</strong> Accepting a tip offer only creates a match. Never send money to another user outside the app; report anyone who asks you to.</p>
            </div>
          </div>
          <p className="text-sm text-gray-500">Questions? Use the Contact page and we will get back to you by email.</p>
        </Card>
      </div>
    </div>
  );
};

export default RefundPolicy;
